import { z } from 'zod';
import { financingBrokerageSubventionServiceConfigSchema } from '../configurations/FinancingBrokerageSubventionServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderFinancingBrokerageSubventionDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.FINANCING_BROKERAGE_SUBVENTION]: financingBrokerageSubventionServiceConfigSchema,
    }),
});

export { servicesProviderFinancingBrokerageSubventionDataSchema };
//# sourceMappingURL=ServicesProviderFinancingBrokerageSubventionData.js.map
